import React from "react";
import { Box } from "@mui/material";
import CartItemCard from "./CartItemCard";

const CartItemList = ({ items, onRemove, onUpdateQuantity }) => (
  <Box sx={{ flex: 2 }}>
    {items.map((item, idx) => (
      <Box key={idx} mb={3}>
        <CartItemCard
          cartItem={item}
          useMainQuantitySelector
          onDelete={() => onRemove(item)}
          onQuantityChange={(newQty) => onUpdateQuantity(item, newQty)}
          variant="cartPage"
        />
      </Box>
    ))}
  </Box>
);

export default CartItemList;
